<template>
  <Layout>
    <h3 class="page-title">{{ $t("open_positions") }}</h3>
    <div class="filter-wrapper">
      <ProgramFilters />

      <div class="justify-end-div">
        <ExpandableSearch />
        <div class="log-icon-wrapper">
          <img src="@/assets/images/logIconNew.svg" @click="showLogModal" class="log-icon" />
          <span class="tooltip">{{ $t('log_records') }}</span>
        </div>        <LogModal
          :visible="isLogModalVisible"
          :on-hide="hideLogModal"
          :data="logData"
      />
        <router-link :to="`/positions/new`">
          <div class="justify-end-add-btn no-text-select">
            <img src="../assets/images/plus.svg" />
            <span>{{$t('add_new')}}</span>
          </div>
          </router-link>
      </div>
      <add-open-position-modal
      :is-visible="showAddModalVisible"
      :on-close="() => showAddModalVisible = false"
      />
    </div>

    <div class="program-list-grid">
      <PositionCard
          v-for="item in positionsData.data"
          :is-loading="isLoading"
          :title="item.title"
          :description="item.description"
          :to="`/positions/${item.positionId}`"
          :remaining="item.remaining"
          :is-publish="item.published"
          :value1="item.targetHiringCount"

      />

      <PositionCard v-if="isLoading" />
      <PositionCard v-if="isLoading" />
      <PositionCard v-if="isLoading" />
    </div>


    <div class="pagination-align-center">
      <Pagination :current-page="1" :total-items="positionsData.total" :per-page="20" :on-page-change="handlePage"/>
    </div>
  </Layout>
</template>

<script>
import ExpandableSearch from "@/components/ExpandableSearch.vue";
import Layout from "@/components/layouts/Layout.vue";
import ProgramCard from "@/components/ProgramCard.vue";
import Pagination from "@/components/Pagination.vue";
import ProgramFilters from "@/components/tables/Program/ProgramFilters.vue";
import PositionCard from "@/components/PositionCard.vue";
import AddOpenPositionModal from "@/components/modals/AddOpenPositionModal.vue";
import openPositionsService from "@/service/openPositionsService";
import LogModal from "@/components/modals/LogModal.vue";

export default {
  components: {
    LogModal,
    AddOpenPositionModal,
    PositionCard,
    ProgramFilters,
    Pagination,
    ProgramCard,
    Layout,
    ExpandableSearch
  },
  data() {
    return {
      logData:[],
      isLogModalVisible:false,
      isLoading: true,
      positionsData: {},
      currentPage: 1,
      showAddModalVisible: false,
    }
  },
  watch: {
    $route() {
      this.handlePage(1);
    }
  },
  mounted() {
    this.getLogs(this.$i18n.locale)
  },
  methods: {
    getLogs(lang){
      openPositionsService.getLogs(lang).then((res) => {
        this.logData=res.data.data.data;
      })
    },
    showLogModal(){
      this.isLogModalVisible=true;
    },
    hideLogModal(){
      this.isLogModalVisible=false;
    },
    handlePage(page) {
      if (this.isLoading && this.currentPage !== 1) return;
      this.isLoading = true;
      this.currentPage = page;

      const routeQuery = this.$route.query;
      const tempFilters = [];

      if (routeQuery.searchText) {
        tempFilters.push({
          key: 'searchText',
          value: routeQuery.searchText
        });
      }

      if (routeQuery.startAt) {
        tempFilters.push({
          key: 'startAt',
          value: routeQuery.startAt
        });
      }

      if (routeQuery.startAtEnd) {
        tempFilters.push({
          key: 'startAtEnd',
          value: routeQuery.startAtEnd
        });
      }

      if (routeQuery.finishAt) {
        tempFilters.push({
          key: 'finishAt',
          value: routeQuery.finishAt
        });
      }

      if (routeQuery.finishAtEnd) {
        tempFilters.push({
          key: 'finishAtEnd',
          value: routeQuery.finishAtEnd
        });
      }

      if (routeQuery.isPublish) {
        if (routeQuery.isPublish === "1") {
          tempFilters.push({
            key: 'isPublish',
            value: "1"

          })
        } else if (routeQuery.isPublish === "0") {
          tempFilters.push({
            key: 'isPublish',
            value: "0"
          })
        }
      }

      openPositionsService.getPositions(page, tempFilters).then(res => {
        this.positionsData = res.data.data;
        this.isLoading = false;
      }).catch(err => {
        this.$snackbar.add({
          text: err.response.data.message,
          type: 'danger'
        });
      });
    },

  }

}
</script>

<style scoped>
.page-title {
  font-family: euclid_medium, sans-serif;
  font-size: 20px;
  color: #040C2D;
  margin-bottom: 20px;
}
.filter-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.filter-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
}
.filter-dropdown {
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
  font-size: 12px;
  color: #344054;
  font-feature-settings: 'clig' off, 'liga' off;
  border-radius: 8px;
  padding: 8px;
  background-color: #f2f2f2;
  position: relative;
  cursor: pointer;
}
.dropdown-text {
  font-size: 12px;
  color: #344054;
  font-feature-settings: 'clig' off, 'liga' off;
  font-weight: 500;
  font-style: normal;
  white-space: nowrap;
}

.program-list-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

@media (max-width: 1024px) {
  .program-list-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .program-list-grid {
    grid-template-columns: repeat(1, 1fr);
  }
}
</style>
